//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productLangs', {
//        templateUrl: 'views/components/views/productLangs/productLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'productLangsService', function ($stateParams, productLangsService) {
//            const vm = this;
//            let prodId = $stateParams.prod_id;
            
//            vm.model = {
//                itemsListProductLanguages: []
//            };

//            async function loadProductLanguages() {
//                vm.model.itemsListProductLanguages = (await productLangsService.listProductLanguages({ prod_id: prodId }));
//            }

//            vm.$onInit = function () {
//                loadProductLanguages();
//            };
//        }]
//    });
//})();
